import React, { useContext, useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import {
  Box,
  Button,
  Container,
  colors,
  Typography,
  makeStyles
} from '@material-ui/core';

import Page from 'src/components/Page';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const Login = () => {

  const classes = useStyles();

  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem('token');
    localStorage.removeItem('login');
    localStorage.removeItem('profile');
    localStorage.removeItem('avatar');
    localStorage.removeItem('userid');
    localStorage.removeItem('firstname');
    localStorage.removeItem('lastname');
    localStorage.removeItem('companyid');
    localStorage.removeItem('company');
    localStorage.removeItem('companylogo');
    localStorage.removeItem('companylogowidth');
    localStorage.removeItem('companylogoheigth');
    localStorage.removeItem('deviceid');
    localStorage.removeItem('userexternalid');
    localStorage.removeItem('authenticateDevice');
  }, []);

  return (
    <Page
      className={classes.root}
      title="ATM"
    >
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="md">
          <Typography
            align="center"
            style={{ color: colors.red[600] }}
            variant="h1"
          >
            <b>Limpesa de Dados Locais:</b>
          </Typography>
          <Typography
            align="center"
            color="textPrimary"
            variant="h2"
          >
            Dados locais foram excluídos
          </Typography>
          <Typography
            align="center"
            color="textPrimary"
            variant="h5"
          >
            Armazenamento Local da aplicação foi reinicializado.
          </Typography>

          <Box textAlign="center">
            <img
              alt="Under development"
              className={classes.image}
              src="/static/logo.svg"
            />
          </Box>
          <Box textAlign="center">
            <Button
              color="secondary"
              component="a"
              href={'/login'}
              variant="contained"
            >
              Efetar Login
            </Button>
          </Box>
        </Container>
      </Box>
    </Page >
  );
};

export default Login;
